import { Alert } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { ConfirmDialogState } from './useConfirmDialog'

interface EnhancedConfirmDialogProps {
    dialogState: ConfirmDialogState | null
    onConfirm: () => void
    onCancel: () => void
    onClose: () => void
}

export default function EnhancedConfirmDialog({
    dialogState,
    onConfirm,
    onCancel,
    onClose,
}: EnhancedConfirmDialogProps) {
    if (!dialogState) return null

    const { isOpen, options } = dialogState
    const {
        title,
        message,
        confirmText,
        cancelText,
        severity,
        confirmButtonColor,
        cancelButtonColor,
        confirmButtonVariant,
        cancelButtonVariant,
    } = options

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby='enhanced-confirm-dialog-title'
            aria-describedby='enhanced-confirm-dialog-description'
            maxWidth='sm'
            fullWidth
        >
            <DialogTitle id='enhanced-confirm-dialog-title'>
                <Alert severity={severity}>
                    <h3 style={{ margin: 0 }}>{title}</h3>
                </Alert>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id='enhanced-confirm-dialog-description'>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    onClick={onCancel}
                    color={cancelButtonColor}
                    variant={cancelButtonVariant}
                    autoFocus
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    color={confirmButtonColor}
                    variant={confirmButtonVariant}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
} 